export const formatNumber = (number, direction) => {
  if (direction) {
    const cleanedString = number.replace(/\s/g, '');
    if (!cleanedString) {
      return null;
    }

    return parseFloat(cleanedString);
  }

  return number.toLocaleString('hu-HU', {
    useGrouping: true,
    groupingSeparator: ' ',
  });
};
